// extracted by mini-css-extract-plugin
module.exports =  {"dropdownTitle":"DropdownTitle-module__dropdownTitle___IbOCc"};